export class Student {
    name: string;
    fatherName: string;
    motherName: string;        
}